import React from 'react';
import ReactDOM from 'react-dom/client';
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { prefetchHomeBackgrounds } from './hooks/useHomeBackground';

const MOBILE_MAX_WIDTH = 768;

if (
  window.location.pathname === '/' &&
  window.innerWidth > MOBILE_MAX_WIDTH &&
  localStorage.getItem('@beviAjudaGui:auth')
) {
  prefetchHomeBackgrounds();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
